import { connect } from "react-redux";
import PropertiesList from "./PropertiesList";

import { init, getReferentielsList } from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		propertiesList: state.properties.propertiesList,
		page: state.properties.page,
		pages: state.properties.pages,
		pageSize: state.properties.pageSize,
		nbItems: state.properties.propertiesList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "properties"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(PropertiesList);


// WEBPACK FOOTER //
// src/containers/admin/properties/PropertiesContainer.js